var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.524 0 20.002 4.478 20.002 10.002C20.002 15.525 15.524 20.002 10 20.002C4.476 20.003 1.6749e-07 15.525 1.6749e-07 10.002C-0.000999833 4.478 4.476 0 10 0ZM9.996 8.25C9.75093 8.25033 9.51452 8.34065 9.33165 8.50379C9.14878 8.66694 9.03218 8.89156 9.004 9.135L8.997 9.251L9.001 14.753L9.007 14.869C9.03495 15.1129 9.15164 15.338 9.33485 15.5014C9.51807 15.6649 9.75499 15.7552 10.0005 15.7552C10.246 15.7552 10.4829 15.6649 10.6661 15.5014C10.8494 15.338 10.9661 15.1129 10.994 14.869L11 14.752L10.996 9.25L10.989 9.133C10.9601 8.88976 10.8429 8.66559 10.6597 8.50301C10.4765 8.34043 10.24 8.25076 9.995 8.251L9.996 8.25ZM10.001 4.501C9.66908 4.501 9.35076 4.63285 9.11606 4.86756C8.88135 5.10226 8.7495 5.42058 8.7495 5.7525C8.7495 6.08442 8.88135 6.40274 9.11606 6.63744C9.35076 6.87215 9.66908 7.004 10.001 7.004C10.1653 7.00393 10.3279 6.97151 10.4797 6.90858C10.6315 6.84565 10.7693 6.75345 10.8854 6.63724C11.0016 6.52102 11.0937 6.38308 11.1565 6.23127C11.2193 6.07947 11.2516 5.91678 11.2515 5.7525C11.2514 5.58822 11.219 5.42555 11.1561 5.2738C11.0932 5.12205 11.0009 4.98418 10.8847 4.86806C10.7685 4.75194 10.6306 4.65984 10.4788 4.59704C10.327 4.53423 10.1643 4.50193 10 4.502L10.001 4.501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.63be37d5b3373e4c109156bfe9d379db.svg";
export { ForwardRef as ReactComponent };